import styled from "styled-components";
import { connect } from "react-redux";
import { signInEmailAPI, signOutAPI } from "../../store/actions";
import React, { useState } from 'react';
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { validate } from "../Shared/inputValidator";
import { Button, ButtonLink, Field, Label, labelStyles } from "../Shared/ui";

const QuickRegistration = (props) => {

  const [fullname, setFullname] = useState('');
  const [gender, setGender] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [dob, setDob] = useState([0,0,0]);
  const [isInprocess, setIsInprocess] = useState(false);

  const handleFullNameChange = (event) => {
    setFullname(event.target.value);
  }

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }

  const handleMobileChange = (event) => {
    setMobile(event.target.value);
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  }

  // dob is stored as [MM, DD, YYYY] and joined with "/" on submit
  const handleDobChange = (event) => {
    const next = [...dob];
    switch (event.target.name) {
      case 'DD_quick':
        next[1] = event.target.value;
        break;
      case 'MM_quick':
        next[0] = event.target.value;
        break;
      case 'YY_quick':
        next[2] = event.target.value;
        break;
      default:
        break;
    }
    setDob(next);
  }

  const singIn = (event) => {
    event.preventDefault();
    if(validate(["fullname_quick", "email_quick", "mobile_quick", "password_quick", "password1_quick", "DD_quick", "MM_quick", "YY_quick"])) {
      setIsInprocess(true);
      props.signInEmailAPI(fullname, email, password, gender, dob.join('/'), mobile);
    }
  }

  if (props.user) {
    return (
      <Card>
        <SignedIn>
          <CheckCircle size={40} weight="duotone" />
          <h3>You're signed in</h3>
          <p>Complete your profile and start searching from your account.</p>
          <SignedInActions>
            <ButtonLink href="/account">
              My account <ArrowRight size={18} weight="bold" />
            </ButtonLink>
            <Button $variant="ghost" type="button" onClick={props.signOut}>Log out</Button>
          </SignedInActions>
        </SignedIn>
      </Card>
    );
  }

  return (
    <Card as="form" onSubmit={singIn} noValidate>
      <CardTitle>Create your profile</CardTitle>
      <CardSub>It takes about a minute. You can add photos and details later.</CardSub>

      <Field>
        <Label htmlFor="fullname_quick">Full name</Label>
        <input
          id="fullname_quick"
          type="text"
          name="fullname_quick"
          autoComplete="name"
          value={ fullname }
          required
          data-error-message="Only alphabets are allowed in full name"
          data-error-type="onlyAlphabets"
          onChange= { handleFullNameChange }/>
      </Field>

      <Field as="fieldset">
        <Legend>Gender</Legend>
        <Segmented>
          <input
            type="radio"
            id="gender1_male"
            name="gender1"
            value="MALE"
            onChange= { handleGenderChange }
            checked = { gender === "MALE" }
          />
          <label htmlFor="gender1_male">Male</label>
          <input
            type="radio"
            id="gender1_female"
            name="gender1"
            value="FEMALE"
            onChange= { handleGenderChange }
            checked = { gender === "FEMALE" }
          />
          <label htmlFor="gender1_female">Female</label>
        </Segmented>
      </Field>

      <Grid2>
        <Field>
          <Label htmlFor="email_quick">Email address</Label>
          <input
            id="email_quick"
            type="email"
            name="email_quick"
            autoComplete="email"
            value={ email }
            required
            data-error-message="Email format not valid"
            data-error-type="email"
            onChange= { handleEmailChange }
          />
        </Field>
        <Field>
          <Label htmlFor="mobile_quick">Mobile number</Label>
          <input
            id="mobile_quick"
            type = "tel"
            name = "mobile_quick"
            inputMode="numeric"
            autoComplete="tel-national"
            value = { mobile }
            required = ""
            data-error-message = "Mobile number format not valid"
            data-error-type = "phone"
            onChange= { handleMobileChange }
          />
        </Field>
      </Grid2>

      <Grid2>
        <Field>
          <Label htmlFor="password_quick">Password</Label>
          <input
            id="password_quick"
            type="password"
            name="password_quick"
            autoComplete="new-password"
            value= { password }
            required=""
            data-error-message="Password must have 8 characters"
            data-error-type="password"
            onChange= { handlePasswordChange }
          />
        </Field>
        <Field>
          <Label htmlFor="password1_quick">Confirm password</Label>
          <input
            id="password1_quick"
            type="password"
            name="password1_quick"
            autoComplete="new-password"
            required=""
            data-error-message="Password is does not match"
            data-error-type="confirmPassword"
            fieldToCompare="password_quick"
          />
        </Field>
      </Grid2>

      <Field as="fieldset">
        <Legend>Date of birth</Legend>
        <DobRow>
          <div>
            <input
              type="number"
              min="1"
              max="31"
              placeholder="DD"
              aria-label="Day"
              inputMode="numeric"
              name="DD_quick"
              required=""
              data-error-message="Day of Birth is Mandatory"
              data-error-type="required"
              onChange= { handleDobChange }
            />
          </div>
          <div>
            <input
              type="number"
              min="1"
              max="12"
              placeholder="MM"
              aria-label="Month"
              inputMode="numeric"
              name="MM_quick"
              required=""
              data-error-message="Day of Birth is Mandatory"
              data-error-type="required"
              onChange= { handleDobChange }
            />
          </div>
          <div>
            <input
              type="number"
              min="1953"
              max="2003"
              placeholder="YYYY"
              aria-label="Year"
              inputMode="numeric"
              name="YY_quick"
              required=""
              data-error-message="Day of Birth is Mandatory"
              data-error-type="required"
              onChange= { handleDobChange }
            />
          </div>
        </DobRow>
      </Field>

      <Button type="submit" $block disabled={isInprocess}>
        { isInprocess ? "Registering..." : <>Register free <ArrowRight size={18} weight="bold" /></> }
      </Button>
    </Card>
  );
};

const Card = styled.div`
  position: relative;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-lg);
  padding: clamp(24px, 3.4vw, 40px);
  margin: 0;
`;

const CardTitle = styled.h3`
  font-size: 26px;
  margin-bottom: 6px;
`;

const CardSub = styled.p`
  color: var(--text-muted);
  font-size: 15px;
  margin-bottom: 24px;
`;

const Legend = styled.legend`
  ${labelStyles}
  padding: 0;
`;

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 14px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const Segmented = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 5px;
  border-radius: var(--radius-pill);
  background: var(--surface-tint);
  border: 1.5px solid var(--border);

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  label {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    border-radius: var(--radius-pill);
    font-weight: 600;
    font-size: 15px;
    color: var(--text-muted);
    cursor: pointer;
    transition:
      background-color 0.3s var(--ease-out),
      color 0.2s ease,
      box-shadow 0.3s var(--ease-out);
  }

  input:checked + label {
    background: var(--surface);
    color: var(--text);
    box-shadow: 0 4px 14px -6px rgb(36 48 94 / 0.35);
  }

  input:focus-visible + label {
    outline: 3px solid var(--coral);
    outline-offset: 2px;
  }
`;

const DobRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr;
  gap: 10px;

  input {
    text-align: center;
    -moz-appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const SignedIn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  svg {
    color: var(--coral);
  }

  h3 {
    font-size: 26px;
    margin: 8px 0 0;
  }

  p {
    color: var(--text-muted);
    margin-bottom: 16px;
  }
`;

const SignedInActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const mapStateToProps = (state) => ({
  user: state.userState.user,
});

const mapDipatchToProps = (dispatch) => ({
  signInEmailAPI: (fullname, email, password, gender, dob, mobile) =>
    dispatch(signInEmailAPI(fullname, email, password, gender, dob, mobile)),
  signOut: () => dispatch(signOutAPI()),
});

export default connect(mapStateToProps, mapDipatchToProps)(QuickRegistration);
